import { Icon as e } from "../icon/index.js";
import { getStyles as t } from "./style.js";
import * as n from "react";
import { Fragment as r, jsx as i, jsxs as a } from "react/jsx-runtime";
import { Portal as o } from "@ark-ui/react/portal";
import { Drawer as s } from "@ark-ui/react/drawer";
// src/design/drawer/index.tsx
var c = n.createContext({
	size: "default",
	placement: "end"
}), l = () => n.useContext(c), u = {
	start: "start",
	end: "end",
	top: "up",
	bottom: "down",
	full: "down"
}, d = ({ children: e, size: t = "default", placement: n = "end", closeOnInteractOutside: r = !1, swipeDirection: a, ...o }) => /* @__PURE__ */ i(c.Provider, {
	value: {
		size: t,
		placement: n
	},
	children: /* @__PURE__ */ i(s.Root, {
		closeOnInteractOutside: r,
		swipeDirection: a ?? u[n],
		...o,
		children: e
	})
}), f = ({ children: e, className: n, ...r }) => /* @__PURE__ */ i(s.Trigger, {
	...r,
	className: t().trigger(n),
	children: e
}), p = ({ children: e, className: n, ...r }) => /* @__PURE__ */ i(s.Backdrop, {
	...r,
	className: t().backdrop(n),
	children: e
}), m = ({ children: e, className: n, ...r }) => {
	let { size: a, placement: o } = l();
	return /* @__PURE__ */ i(s.Positioner, {
		className: t(o, a).positioner(n),
		...r,
		children: e
	});
}, h = ({ children: e, className: n, draggable: r = !1, ...a }) => {
	let { size: o, placement: c } = l();
	return /* @__PURE__ */ i(s.Content, {
		draggable: r,
		...a,
		className: t(c, o).content(n),
		children: e
	});
}, g = ({ children: e, className: n, ...r }) => /* @__PURE__ */ i(s.Title, {
	...r,
	className: t().title(n),
	children: e
}), _ = ({ children: e, className: n, ...r }) => /* @__PURE__ */ i(s.Description, {
	...r,
	className: t().description(n),
	children: e
}), v = ({ children: e, className: n, ...r }) => /* @__PURE__ */ i(s.CloseTrigger, {
	...r,
	className: t().closeTrigger(n),
	children: e
}), y = ({ children: e, className: n }) => /* @__PURE__ */ i("div", {
	className: t().header(n),
	children: e
}), b = ({ children: e, className: n }) => /* @__PURE__ */ i("div", {
	className: t().body(n),
	children: e
}), x = ({ children: e, className: n }) => /* @__PURE__ */ i("div", {
	className: t().footer(n),
	children: e
}), S = ({ children: e, className: n, ...r }) => /* @__PURE__ */ i(s.Grabber, {
	...r,
	className: t().grabber(n),
	children: e
}), C = ({ className: e, ...n }) => /* @__PURE__ */ i(s.GrabberIndicator, {
	...n,
	className: t().grabberIndicator(e)
}), w = ({ children: e, className: t, ...n }) => /* @__PURE__ */ i(s.SwipeArea, {
	...n,
	className: t,
	children: e
}), T = ({ trigger: t, title: n, description: s, closeTrigger: c, children: l, footer: u, rootProps: S, size: C = "default", placement: w = "end" }) => /* @__PURE__ */ a(d, {
	lazyMount: !0,
	unmountOnExit: !0,
	size: C,
	placement: w,
	...S,
	children: [t ? /* @__PURE__ */ i(f, {
		asChild: !0,
		children: t
	}) : null, /* @__PURE__ */ a(o, { children: [/* @__PURE__ */ i(p, {}), /* @__PURE__ */ i(m, { children: /* @__PURE__ */ a(h, { children: [
		/* @__PURE__ */ a(y, { children: [/* @__PURE__ */ i(g, { children: n }), /* @__PURE__ */ i(v, {
			"aria-label": c ? void 0 : "Close",
			children: /* @__PURE__ */ i(r, { children: c ?? /* @__PURE__ */ i(e, {
				name: "X",
				size: "sm"
			}) })
		})] }),
		/* @__PURE__ */ a(b, { children: [s ? /* @__PURE__ */ i(_, { children: /* @__PURE__ */ i(r, { children: s }) }) : null, l] }),
		u ? /* @__PURE__ */ i(x, { children: u }) : null
	] }) })] })]
}), E = () => null;
E.Default = T, E.Root = d, E.Trigger = f, E.Backdrop = p, E.Positioner = m, E.Content = h, E.Title = g, E.Description = _, E.CloseTrigger = v, E.Header = y, E.Body = b, E.Footer = x, E.Grabber = S, E.GrabberIndicator = C, E.SwipeArea = w, E.Portal = o, E.getStyles = t;
export { E as Drawer };

//# sourceMappingURL=index.js.map